import BigNumber from "bignumber.js";
import moment from "moment";
export enum RoundingMode {
  ROUND_UP = "ROUND_UP",
  ROUND_DOWN = "ROUND_DOWN",
  NO_ROUNDING = "NO_ROUNDING",
}
type FormValues = Record<string, string | number | Date | undefined>;

const useDocumentGenerationDetails = () => {
    const formatNumberWithCommas = (number: number, isDecimal = false) => {
        const numberString = number.toString();
        const [integerPart, decimalPart] = numberString.split('.');
        const formattedIntegerPart = integerPart.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ',',
        );
        const formattedDecimalPart = isDecimal
            ? (decimalPart || '.00').padEnd(2, '0')
            : decimalPart
                ? `.${decimalPart}`
                : '';
        return `${formattedIntegerPart}${formattedDecimalPart}`;
    };
    const formatSSN = (numberString: string) => {
        let res = '';
        for (let i = 0; i < numberString.length; i++) {
            if (i === 3 || i === 5) {
                res += `-${numberString[i]}`;
            } else {
                res += `${numberString[i]}`;
            }
        }
        return res;
    };
    const calculateFormula = (
        formula: string,
        values: Record<string, string | number | Date | undefined>,
        isEveryCompany?: boolean,
    ) => {
        const mathVal = '';
        const isPricePerShareNumber = typeof values.price_per_share === 'number';
        const isNumberOfSharesNumber = typeof values.number_of_shares === 'number';
        const isPricePaidNumber = typeof values.price_paid === 'number';
        if (
            formula === 'price_per_share*number_of_shares' &&
            isPricePerShareNumber &&
            isNumberOfSharesNumber
        ) {
            const bigPricePerShare = new BigNumber(values.price_per_share as number);
            const bigNumberOfShares = new BigNumber(values.number_of_shares as number);
            let res = bigPricePerShare.times(bigNumberOfShares);
            if (isEveryCompany) {
                res = res.decimalPlaces(2, BigNumber.ROUND_UP)
            }
            return res.toString();
        }
        if (
            formula === 'price_paid*number_of_shares' &&
            isPricePaidNumber &&
            isNumberOfSharesNumber
        ) {
            const bigPricePaid = new BigNumber(values.price_paid as number);
            const bigNumberOfShares = new BigNumber(values.number_of_shares as number);
            let res = bigPricePaid.times(bigNumberOfShares);
            if (isEveryCompany) {
                res = res.decimalPlaces(2, BigNumber.ROUND_UP);
            }
            return res.toString();
        }
        if (
            formula === '(price_per_share*number_of_shares) - (price_paid*number_of_shares)' &&
            isPricePerShareNumber &&
            isNumberOfSharesNumber &&
            isPricePaidNumber
        ) {
            const bigPricePerShare = new BigNumber(values.price_per_share as number);
            const bigNumberOfShares = new BigNumber(values.number_of_shares as number);
            const bigPricePaid = new BigNumber(values.price_paid as number);
            let production1 = bigPricePerShare.times(bigNumberOfShares);
            let production2 = bigPricePaid.times(bigNumberOfShares);
            if (isEveryCompany) {
                production1 = production1.decimalPlaces(2, BigNumber.ROUND_UP);
                production2 = production2.decimalPlaces(2, BigNumber.ROUND_UP);
                const res = production1.minus(production2);
                return res.toString();
            } else {
                const res = production1.minus(production2);
                return res.toString();
            }
        }
        return mathVal;
    }

    function multiply(firstVale: number, secondValue: number): BigNumber {
        const bigNumner = new BigNumber(firstVale);
        return bigNumner.times(new BigNumber(secondValue));
    }

    function applyRounding(bignumber: BigNumber, roundingMode: RoundingMode, decimalPlaces: number = 2): BigNumber {

        switch(roundingMode) {
            case RoundingMode.ROUND_UP:
                return bignumber.decimalPlaces(decimalPlaces, BigNumber.ROUND_UP);
            case RoundingMode.ROUND_DOWN:
                return bignumber.decimalPlaces(decimalPlaces, BigNumber.ROUND_DOWN);
            default: 
            return bignumber;
        }
     
    }

    const calculateWhitRounding = (fieldName:string, formData:FormValues, roundingMode:RoundingMode) => {
        const {
        price_paid,
        price_per_share,
        number_of_shares
        } = formData
        
        let result:BigNumber;
        if(fieldName === "FMV") {
            result = multiply(Number(price_per_share), Number(number_of_shares));
            result = applyRounding(result, roundingMode);
        } else if(fieldName === "Total_Paid") {
            result = multiply(Number(price_paid), Number(number_of_shares));
            result = applyRounding(result, roundingMode);
        } else {
            let product1 = multiply(Number(price_per_share), Number(number_of_shares));
            let product2 = multiply(Number(price_paid), Number(number_of_shares));
            product1 = applyRounding(product1, roundingMode);
            product2 = applyRounding(product2, roundingMode);
            result = product1.minus(product2);
        }
        return result.toString();
    };

    const formatDate = (date: Date) => {
        return moment(date).format("MMMM DD, YYYY");
    };
    return {
        calculateWhitRounding,
        formatNumberWithCommas,
        formatSSN,
        calculateFormula,
        formatDate,
    }
}

export default useDocumentGenerationDetails;
